import React, { useState, useEffect } from "react";
import { useField } from "formik";
import styled from "styled-components";
import FormField from "components/molecules/FormField";
import { formatterNumber, parserNumber } from "utils/currency";
import { formatterRate, parserRate } from "utils/rate";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
`;

const InputRelativeContainer = styled.div`
  position: relative;
  width: 120px;
`;

const MaxMinAboveInput = styled.div`
  position: absolute;
  top: -12px;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
  color: #99a;
`;

const TinyButton = styled.button`
  background: none;
  border: none;
  color: #99a;
  cursor: pointer;
  padding: 0;
  width: 36px;

  &:hover {
    text-decoration: underline;
  }
`;

const TinyButtonsContainer = styled.div`
  width: 40px
  display: flex;
  font-size: 11px;
  flex-direction: column;
  margin-left: 5px;
  align-items: end;
  justify-content: center;
`;

const CoinsuranceMinMaxFormField = ({ name }) => {
  const [field, meta, helpers] = useField(name);
  const initialValue = { value: 0, min: null, max: null };

  useEffect(() => {
    if (typeof field.value === "undefined") {
      helpers.setValue(initialValue);
    }
  }, []);

  const [showMin, setShowMin] = useState(!!(field.value && field.value.min != null));
  const [showMax, setShowMax] = useState(!!(field.value && field.value.max != null));

  const toggleMin = () => {
    if (showMin) {
      helpers.setValue({ ...field.value, min: null });
      setShowMin(false);
    } else {
      helpers.setValue({ ...field.value, min: 0 });
      setShowMin(true);
    }
  };

  const toggleMax = () => {
    if (showMax) {
      helpers.setValue({ ...field.value, max: null });
      setShowMax(false);
    } else {
      helpers.setValue({ ...field.value, max: 0 });
      setShowMax(true);
    }
  };

  useEffect(() => {
    if (field.value && field.value.min != null) {
      setShowMin(true);
    }
    if (field.value && field.value.max != null) {
      setShowMax(true);
    }
  }, [field.value]);
  return (
    <Container className="exclude-from-global-width">
      <InputWrapper className="exclude-from-global-width">
        <FormField
          name={`${name}.value`}
          size="fullwidth"
          defaultValue="%"
          max={100}
          min={0}
          formatter={formatterRate}
          parser={parserRate}
          type="number"
          maxSize={120}
        />

        {showMin && (
          <InputRelativeContainer className="exclude-from-global-width">
            <MaxMinAboveInput className="exclude-from-global-color">Minimum</MaxMinAboveInput>
            <FormField
              name={`${name}.min`}
              size="fullwidth"
              style={{
                width: "100%",
              }}
              min={0}
              defaultValue="$"
              formatter={formatterNumber}
              parser={parserNumber}
              type="number"
              maxSize={120}
            />
          </InputRelativeContainer>
        )}
        {showMax && (
          <InputRelativeContainer className="exclude-from-global-width">
            <MaxMinAboveInput className="exclude-from-global-color">Maximum</MaxMinAboveInput>
            <FormField
              name={`${name}.max`}
              size="fullwidth"
              style={{
                width: "100%",
              }}
              min={field?.value?.min || 0}
              defaultValue="$"
              formatter={formatterNumber}
              parser={parserNumber}
              type="number"
              maxSize={120}
            />
          </InputRelativeContainer>
        )}
      </InputWrapper>

      <TinyButtonsContainer className="exclude-from-global-width">
        <TinyButton type="button" onClick={toggleMin}>
          {showMin ? "[-]" : "[+]"} min
        </TinyButton>
        <TinyButton type="button" onClick={toggleMax}>
          {showMax ? "[-]" : "[+]"} max
        </TinyButton>
      </TinyButtonsContainer>
    </Container>
  );
};

export default CoinsuranceMinMaxFormField;
